import { useMemo } from 'react';
import { toZonedISODateKey } from '@lp/features/Scheduler/utils';
import { isSameCSWindow } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/period.utils';
import { OrganType } from '@/api/apis/case';
import { CSResourcesWithShifts, CSShiftType } from '@/api/apis/resources/schedule';

type PhoneSupportDayTotals = Record<OrganType, number> & {
  day: Date;
  isCurrentMonth: boolean;
};

export const getTotalsByDay = (day: Date, startDay: Date, shiftsData: CSResourcesWithShifts): PhoneSupportDayTotals => {
  const key = toZonedISODateKey(day);
  const dayTotals: PhoneSupportDayTotals = {
    [OrganType.Lungs]: 0,
    [OrganType.Heart]: 0,
    [OrganType.Liver]: 0,
    [OrganType.Kidney]: 0,
    day,
    isCurrentMonth: isSameCSWindow(day, startDay),
  };

  if (dayTotals.isCurrentMonth) {
    Object.values(shiftsData).forEach((shift) => {
      const currentShift = shift.days[key];
      if (currentShift && currentShift.shiftType === CSShiftType.PhoneSupport && currentShift.organs) {
        // eslint-disable-next-line no-return-assign
        currentShift.organs.forEach((organ) => (dayTotals[organ] += 1));
      }
    });
  }

  return dayTotals;
};

export const usePhoneSupportDayTotals = (
  days: Date[],
  startDay: Date,
  shiftsData: CSResourcesWithShifts,
): PhoneSupportDayTotals[] => {
  return useMemo(() => {
    const totals = days.map((day) => {
      return getTotalsByDay(day, startDay, shiftsData);
    });

    return totals;
  }, [days, shiftsData, startDay]);
};
